export enum EslQqToolParametersEnum {
  language = 'language',
  schoolCode = 'schoolCode',
  argoIdentifier = 'argo_identifier',
  clientName = 'client_name',
}
